export default __webpack_public_path__ + "static/media/timely.52852589.png";